// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3lKIVc4WEu4U_H {\n  color: #8993A4;\n  padding: 0 4px;\n}\n._3lKIVc4WEu4U_H:hover {\n  color: #091E42;\n}\n.Rf_lDCmZgg5mPt {\n  margin: 0;\n}\n._2K0B76NHbTES8D {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 12px;\n}\n.C8Tayx3l28pXCh {\n  display: block;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"downloadLink": "_3lKIVc4WEu4U_H",
	"exportButton": "Rf_lDCmZgg5mPt",
	"buttons": "_2K0B76NHbTES8D",
	"exportHistoryText": "C8Tayx3l28pXCh"
};
export default ___CSS_LOADER_EXPORT___;
